import { Component, EventEmitter, Input, Output, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgClass, NgIf } from '@angular/common';
import { B3CardModule, B3UseButtonModule } from '@b3/design-system-lib';
import { Router } from '@angular/router';
import { GtmService } from 'src/app/core/gtm/gtm.service';

export type CardSize = 'small' | 'medium' | 'large';

@Component({
  selector: 'app-generic-card',
  templateUrl: './generic-card.component.html',
  styleUrls: ['./generic-card.component.css'],
  standalone: true,
  imports: [B3CardModule, B3UseButtonModule, NgClass, NgIf],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class GenericCardComponent {
  @Input() title: string = '';
  @Input() content: string = '';
  @Input() buttonTitle: string = 'Acessar Plataforma';
  @Input() buttonCenter: boolean = true;
  @Input() buttonDisabled: boolean = false;
  @Input() leftRightPadding: number = 20;
  @Input() href: string = '';
  @Input() icon: string = '../../../assets/icons/open_in_new.svg';
  @Input() disabledIcon: string = '../../../assets/icons/lock.svg';
  @Input() disabled: boolean = false;
  @Input() overlayMsg: string = '';
  @Input() showOverlay: boolean = false;
  @Input() size: CardSize = 'medium';
  @Output() onClickCard: EventEmitter<any> = new EventEmitter();
  @Input() routerCard: string = '';

  constructor(private router: Router, private gtmService: GtmService) { }

  onClick(href: string): void {
    if (this.buttonDisabled || (this.disabled && this.showOverlay)) return;

    this.gtmService.pushEvent('card_click', {
      card_title: this.title, buttonTitle: this.buttonTitle, card_href: href || this.routerCard
    });

    this.onClickCard.emit(href);
    if (this.routerCard) this.router.navigate([this.routerCard]);
  }
}
